import React from 'react'

function Logo() {
    return (
        <ul className="nav justify-content-end">
            <li className="nav-item" style={{ paddingRight: "2rem" }}>
                <img src={"../image/ISO.png"} alt={""} />
            </li>
        </ul>

    )
}

export default Logo